import dbc from '@/api/configCenter/dimension.organization';

const queryList = {
  namespaced: true,
  state: {},

  actions: {
    // 预算组织-模块

    /**
     * 获取预算组织所有数据
     * @param {*} store
     * @param {*} param
     */
    getBudgetOrgList(context, param) {
      return dbc.getBudgetOrgList(param).then((content) => content.list);
    },

    /**
     * 获取 某一条 预算组织信息
     * @param {*} store
     * @param {*} param
     */
    getBudgetOrgById(context, param) {
      return dbc.getBudgetOrgById(param).then((content) => content.data);
    },

    /**
     * 保存一条预算组织数据
     * @param {*} store
     * @param {*} param
     */
    saveBudgetOrg(context, param) {
      return dbc.saveBudgetOrg(param).then((content) => content.data);
    },

    /**
     * 删除一条预算组织数据数组
     * @param {*} param
     */
    deleteBudgetOrgById(context, param) {
      return dbc.deleteBudgetOrgById(param).then((content) => content.data);
    },
    /**
     * 同步预算组织
     * @param {*} param
     */
    syncBudgetOrg(context, param) {
      return dbc.syncBudgetOrg(param).then((content) => content.data);
    },
  },

  mutations: {},
};

export default queryList;
